export default __webpack_public_path__ + "static/media/Profile.12bc9585.jpg";